export const MOVEABLE_LISTING_STATES = ['EXPIRED', 'PURGED', 'DELISTED', 'SOLD', 'PENDING']
